import { ColDef } from 'ag-grid-community'
import { AssetNameCell, ColDefWithLoading, CurrencyCell } from 'components/core-v2'

import { formatUnits } from '@/utilities/number'

export const COLUMN_DEFS: ColDefWithLoading[] = [
  {
    headerName: 'Name',
    field: 'assetName',
    minWidth: 200,
    flex: 0.22,
    cellStyle: { display: 'flex' },
    cellRenderer: AssetNameCell,
    loadingCellWidth: 'xl'
  },
  {
    headerName: 'Asset ID',
    field: 'assetId',
    minWidth: 140,
    flex: 0.1,
    loadingCellWidth: 'md'
  },
  {
    headerName: 'Asset class',
    field: 'assetClass',
    minWidth: 140,
    flex: 0.18,
    loadingCellWidth: 'sm'
  },
  {
    headerName: 'Type',
    field: 'performanceType',
    minWidth: 150,
    flex: 0.1,
    loadingCellWidth: 'md'
  },
  {
    headerName: 'Units',
    field: 'units',
    minWidth: 140,
    flex: 0.1,
    loadingCellWidth: 'sm',
    type: 'rightAligned',
    valueFormatter: ({ value }) => (value ? formatUnits(value) : '–')
  },
  {
    headerName: 'Weight',
    field: 'weight',
    minWidth: 140,
    flex: 0.1,
    loadingCellWidth: 'sm',
    type: 'rightAligned'
  },
  {
    headerName: 'Amount',
    field: 'amount',
    minWidth: 140,
    flex: 0.1,
    loadingCellWidth: 'sm',
    type: 'rightAligned',
    cellRenderer: CurrencyCell({
      currencyFieldName: 'currency',
      fieldName: 'amount',
      variant: 'full'
    })
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}
